module.exports = __webpack_public_path__ + "img/eshop.6119a961.jpg";